import React from "react";
import "./help.css";
import logoImage from "../../assets/logo_trucktronix.png";
import { useNavigate } from "react-router-dom";

const Help = () => {
  const navigate = useNavigate();

  return (
    <div className="hlp-page">
      <header className="hlp-header">
        <div className="hlp-header-left">
          <button
            type="button"
            className="root-btn-back"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-chevron-left" aria-hidden="true" />
            Back
          </button>
        </div>

        <div className="hlp-header-right">
          <div className="hlp-header-title">
            <div className="hlp-header-title-main">Help</div>
            <div className="hlp-header-title-sub">Trucktronix Support</div>
          </div>
          <img src={logoImage} alt="Trucktronix" className="hlp-logo" />
        </div>
      </header>

      <main className="hlp-main">
        <section className="hlp-card">
          <div className="hlp-card-top">
            <div className="hlp-chip">
              <i className="bi bi-headset" aria-hidden="true" />
              Contact Us
            </div>
            <div className="hlp-muted">
              We usually respond within business hours.
            </div>
          </div>

          <div className="hlp-body">
            <p className="hlp-copy">
              At Trucktronix, customer service is an integral part of our
              offering. We take pride in providing expert advice and continuous
              technical support to our valued clients. For further details on
              our on-board scale solutions, please don't hesitate to reach out.
            </p>

            <div className="hlp-grid">
              <div className="hlp-item">
                <div className="hlp-label">Phone</div>
                <div className="hlp-value">
                  <a className="hlp-link" href="tel:1300342147">
                    1300 342 147
                  </a>
                </div>
              </div>

              <div className="hlp-item">
                <div className="hlp-label">International</div>
                <div className="hlp-value">
                  <a className="hlp-link" href="tel:+61473911911">
                    +61473911911
                  </a>
                </div>
              </div>

              <div className="hlp-item hlp-item-wide">
                <div className="hlp-label">Email</div>
                <div className="hlp-value hlp-wrap">
                  <a className="hlp-link" href="mailto:sales@haulweigh.com">
                    sales@haulweigh.com
                  </a>
                  <span className="hlp-sep">,</span>
                  <a className="hlp-link" href="mailto:support@haulweigh.com">
                    support@haulweigh.com
                  </a>
                </div>
              </div>

              <div className="hlp-item hlp-item-wide">
                <div className="hlp-label">Mail</div>
                <div className="hlp-value hlp-wrap">
                  PO BOX 294, HORSLEY PARK, 2175, NSW, AUSTRALIA
                </div>
              </div>

              <div className="hlp-item hlp-item-wide">
                <div className="hlp-label">Trading Hours</div>
                <div className="hlp-value">MON – FRI: 9AM – 5PM (AEST)</div>
              </div>
            </div>

            <div className="hlp-note">
              <i className="bi bi-info-circle" aria-hidden="true" />
              If you’re calling about a truck weight issue, you must have fitted
              HaulWeigh scale in your truck.
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Help;
